import React from "react";
import { useNavigate } from "react-router-dom";
import "./Welcome.css";

export default function Welcome() {
  const navigate = useNavigate();

  return (
    <div className="welcome-container">
      <div className="welcome-card">
        <h1 className="welcome-logo">Ve Meet</h1>
        <p className="welcome-sub">Secure & simple video conferencing</p>

        <div className="welcome-actions">
          <button className="btn btn-host" onClick={() => navigate("/plan")}>
            Host Meeting
          </button>
          <button className="btn btn-guest" onClick={() => navigate("/guest")}>
            Join Meeting
          </button>
        </div>

        <p className="small-note">Admin-generated Host Code is required to host a meeting.</p>
      </div>
    </div>
  );
}
